import React from "react";
import { DateTime } from "luxon";

export interface JobFilterContextType {
    onFilterChange: (filter: { city: string; date: string }) => void;
    defaultFormattedDate?: string;
    selectedCity: string | "Denver" | "Las Vegas" | "Phoenix";
    setSelectedCity: (city: string | "Denver" | "Las Vegas" | "Phoenix") => void;
    setDefaultFormattedDate: (date: string) => void;
    isoDate: string;
    cities: string[];
}

export const JobFilterContext = React.createContext<JobFilterContextType>({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFilterChange: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSelectedCity: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setDefaultFormattedDate: () => {},
    selectedCity: "Denver",
    defaultFormattedDate: DateTime.now().toFormat("dd MMM"),
    isoDate: DateTime.now().toISO() ?? "",
    cities: ["Denver", "Las Vegas", "Phoenix"],
});

export const JobFilterProvider = React.memo(({ children }: { children?: React.ReactNode }) => {
    const [selectedCity, setSelectedCity] = React.useState("Denver");
    const [defaultFormattedDate, setDefaultFormattedDate] = React.useState(DateTime.now().toFormat("dd MMM"));
    const [isoDate, setIsoDate] = React.useState(DateTime.now().toISO() ?? "");

    const onFilterChange = React.useCallback((filter: { city: string; date: string }) => {
        console.log("Filter changed:", filter);
        setSelectedCity(filter.city);
        setDefaultFormattedDate(DateTime.fromISO(filter.date).toFormat("dd MMM"));
        setIsoDate(filter.date);
    }, []);

    return (
        <JobFilterContext.Provider
            value={{
                onFilterChange,
                selectedCity,
                defaultFormattedDate,
                cities: ["Denver", "Las Vegas", "Phoenix"],
                setSelectedCity,
                setDefaultFormattedDate,
                isoDate,
            }}>
            {children}
        </JobFilterContext.Provider>
    );
});
